import { useLoginModal } from './LoginModalContext';
import { useCallback, useEffect, useState } from 'react';
import EnterPhone from '@/pages/login/EnterPhone';
import VerifyPhone from '@/pages/login/VerifyPhone';
import { useQueryClient } from '@tanstack/react-query';
import { firebaseAuth } from '@/lib/Firebase';

export default function LoginModal() {
  const { isOpen, closeModal, onLoginSuccess } = useLoginModal();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [step, setStep] = useState(0);

  // Reset state when modal opens
  useEffect(() => {
    if (isOpen) {
      setPhoneNumber('');
      setStep(0);
    }
  }, [isOpen]);

  // Close on Escape key
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeModal();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, closeModal]);

  const onChangePhone = useCallback((phone: string) => {
    setPhoneNumber(phone);
  }, []);

  const onNext = useCallback(() => {
    setStep(1);
  }, []);

  const onVerified = useCallback(async (verified: boolean, isNewUser?: boolean) => {
    if (verified) {
      onLoginSuccess();
    }
  }, [onLoginSuccess]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9998] flex items-center justify-center bg-primary/80 backdrop-blur-lg">
      <button
        onClick={closeModal}
        aria-label="Close"
        className="absolute top-4 right-4 flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
      <div className="w-full max-w-md mx-auto p-4">
        {step === 0 ? (
          <EnterPhone
            onNext={onNext}
            phoneNumber={phoneNumber}
            onChangePhone={onChangePhone}
          />
        ) : (
          <VerifyPhone
            phoneNumber={phoneNumber}
            onVerified={onVerified}
          />
        )}
      </div>
    </div>
  );
}
